import Base from '../Base'

class Dict extends Base {
  constructor () {
    super()
    this.subjectUrl = '/class/subjects'
    this.gradeUrl = '/base_info/grades'
    this.levelUrl = '/class/levels'
    this.termUrl = '/class/terms'
    this.queryAdverseUrl = 'official/poster/user_msg'
    this.closeAdverseUrl = '/official/ad/show_record'
    this.queryAreaOperatorUrl = '/v1/ocean/open/operational/user/get'
    this.getWeclassOperatorUrl = '/operations/school_operator'
    this.countryCodeUrl = '/sms/country_code/list'
    this.getWeclassLoginStatusUrl = '/schools/get_login_msg_status'
    this.changeWeclassLoginStatusUrl = '/schools/change_login_msg_status'
  }

  /**
   * 获取学科信息
   */
  fetchSubjects () {
    return this.sendGet(this.subjectUrl)
  }

  /**
   * 获取年纪信息
   * @param { subject_id } params
   */
  fetchGrades (params) {
    return this.sendGet(this.gradeUrl, params)
  }

  /**
   * 获取 level 信息
   * @param { subject_id, grade_id } params
   */
  fetchLevels (params) {
    return this.sendGet(this.levelUrl, params)
  }

  /**
   * 获取学期信息
   * @param { subject_id, grade_id, level } params
   */
  fetchTerms (params) {
    return this.sendGet(this.termUrl, params)
  }

  /**
   * 获取广告位通知
   */
  queryAdverse (params) {
    return this.sendGet(this.queryAdverseUrl, params)
  }

  /**
   * 关闭广告位通知
   */
  closeAdverse (params) {
    return this.sendGet(this.closeAdverseUrl, params)
  }

  /**
   * 获取机构分区运营负责人
   */
  queryAreaOperator () {
    return this.sendGet(this.queryAreaOperatorUrl, {})
  }

  /**
   * 获取机构是否需要续费
   */
  getSchoolPeriodMsg () {
    return this.sendGet('/schools/functionPeriodTipMsg')
  }

  /**
   * 获取未来好课试用权限是否购买，是否认证状态
   */
  getSchoolWLHKStatus () {
    return this.sendGet('/schools/canBuyWLHK')
  }

  /**
   * 获取weclass专属运营信息
   */
  getWeclassOperator (params) {
    return this.sendGet(this.getWeclassOperatorUrl, params)
  }
  /*
   * 获取国家区号
   * @param { data_type, cooperation_status } params
   */
  getCountryCode (params) {
    return this.sendGet(this.countryCodeUrl, params)
  }

  /**
   * @desc 获取weclass登录状态，是否需要提示专属运营
   */
  getWeclassLoginStatus (params) {
    return this.sendGet(this.getWeclassLoginStatusUrl, params)
  }

  /**
   * @desc 更改weclass登录状态，之后无须提示专属运营
   */
  changeWeclassLoginStatus (params) {
    return this.sendPost(this.changeWeclassLoginStatusUrl, params, true)
  }
}

export default new Dict()
